import { SET_USER_INFO, SET_IS_ACT_AS_USER } from "../action/app";
import cloneDeep from "lodash/cloneDeep";

export default function appReducer(
  state = {
    userInfo: null,
  },
  action
) {
  switch (action.type) {
    case SET_USER_INFO:
      return {
        ...state,
        userInfo: cloneDeep(action.payload),
      };
    case SET_IS_ACT_AS_USER:
      return {
        ...state,
        isActAsUser: cloneDeep(action.payload),
      };
    default:
      return state;
  }
}
